import packageConfig from '../package.json'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Platform from '@monogrid/js-utils/lib/Platform'

import router from './plugins/router.js'
import './plugins/analytics.js'
import './plugins/locale.js'
import VueMeta from 'vue-meta'
import VueEvents from 'vue-event-handler'
import Preloader from './preloader'
import onlineApolloProvider from './services/CMS'
import auth from './services/CMSAuth'
import SEOVImg from './atoms/SEOVImg'

// import CMSOffline from './services/CMSOffline'
// import cmsOfflineCatalog from './services/CMSOfflineCatalog.json'
// import cmsOfflineSchema from './services/CMSOfflineSchema.graphql'

// usage: https://vuetifyjs.com/
import vuetify from './plugins/vuetify'
// usage: https://github.com/declandewet/vue-meta
Vue.use(VueMeta)
// usage: https://github.com/sandeepk01/vue-event-handler
Vue.use(VueEvents)
Vue.component('seo-v-img', SEOVImg)
//
//
// Initialization of the preloader app (placed on the HTML)
//
//
const preloaderInstance = new Vue(Preloader)

// management of languages
router.beforeEach((to, from, next) => {
  // set current language on change route
  preloaderInstance.visible = true
  if (packageConfig.multilanguage) {
    if (to.params.language) {
      Vue.config.language = to.params.language || 'en'
    }
  } else {
    Vue.config.language = 'en'
  }
  next()
})
router.afterEach((to, from) => {
  preloaderInstance.visible = false
})

const getQueryStringParams = query => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
          const [key, value] = param.split('=')
          params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
          return params
        }, {}
        )
    : {}
}

const queryStrings = getQueryStringParams(window.location.search)

//
//
// Initialization of the app (placed on the HTML)
//
//
auth.getLoggedUser().then(user => {
  new Vue({ // eslint-disable-line
    el: '#app',
    router,
    vuetify,
    /**
     * this is an example of using the online server in all the stages
     * and using offline data in a production stage (for example if deployed on client servers)
     * rename the production stage to "production" if you want to use this configuration
     */
    apolloProvider: onlineApolloProvider,
    /**
     * use this if you want the online-only version of the CMS data
     */
    // apolloProvider: onlineApolloProvider,
    data () {
      return {
        preloader: preloaderInstance,
        auth,
        queryStrings,
        siteSettings: null,
        databaseUser: null,
        process: {
          env: process.env
        }
      }
    },
    watch: {
      'auth.loggedUser' (value) {
        if (!value) {
          this.databaseUser = null
        }
      }
    },
    methods: {
      getNow () {
        let now = new Date()
        if (queryStrings.now && queryStrings.now.length > 0) {
          try {
            now = new Date(queryStrings.now)
          } catch (e) {
            now = new Date()
          }
        }
        return now
      }
    },
    computed: {
      userIsComplete () {
        return this.databaseUser &&
        this.databaseUser.acceptedTerms &&
        !!this.databaseUser.email &&
        !!this.databaseUser.name &&
        !!this.databaseUser.employment &&
        !!this.databaseUser.ageBracket &&
        !!this.databaseUser.company &&
        !!this.databaseUser.jobTitle &&
        !!this.databaseUser.jobExperienceLevel
      },
      platform () {
        return Platform
      },
      multilanguage () {
        return packageConfig.multilanguage
      }
    },
    // this block allows passing props to the main App
    // these props are set by html-webpack-plugin in the html
    // and the values are taken from git-revision-webpack-plugin
    render (createElement) {
      return createElement(App, {
        props: {
          preloader: preloaderInstance
        }
      })
    }
  })

  return null
}).catch(e => { console.error(e) })
